import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import {
  SlButton,
  SlDrawer,
  SlTooltip,
  SlOption,
  SlSelect,
  SlInput,
  SlTab,
  SlTabGroup,
  SlTabPanel,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import filterSvg from '../../assets/images/filter.svg'

import { useDispatch, useSelector } from "react-redux";

// import { decrement, increment } from '../../redux/counterSlice'

import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { formatDate, formatDateWithTime, formatDateYYYYMMDD, ISODateString, NEWISODateString } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { campaignStatus, roles, langoptions, languageOptions, stateOptions } from "../../utils/constants";
import Paginator from "../../shared/Paginator";
import { debounce } from "../../utils/Debounce";
import config from "../../config";
import { SetCampCount, SetOpsSales, SetComponentId } from "../../redux/counterSlice";
// import CreativeCreation from "../creatives/CreativeCreation";
// import PreviewFrame from "../PreviewFrame";
// import Budget from "./Budget";
// import CreativeSelection from "./CreativeSelection";
// import Start from "./Start";
// import Target from "./Target";
// import Date from "./Date";
import { UpdatedDate } from "../../utils/dateFormat";
import async from "async";

const perPageCount = 50;
// export const newStreamCreativeContext = React.createContext();
function PosWiseImpress() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({
    pageNo: 0,
    pageData: [],
    totalData: [],
  });
  const [loader, setLoader] = useState(false);
  const [langfilter, setLangFilter] = useState("1");
  const [statefilter, setStatefilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState(-1);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [mandalselect, setSelectmandal] = useState(-1);
  const [mandalfilter, setMandalfilter] = useState([]);
  const [target_filter, setTarget_filter] = useState({ lang_id: "1" });
  const [showFilter, setShowFilter] = useState(false)
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  dispatch(SetComponentId(21));

  const getData = async (target_filter = { lang_id: 1, state_id: -1, district_id: -1, mandal_id: -1 }) => {
    try {
      setLoader(true);
      //   console.log(target_filter)
      let url, data;
      if (target_filter.mandal_id > -1) {
        url = "/position-impress/by-mandal";
        data = {
          mandalId: target_filter.mandal_id,
        };
      } else if (target_filter.district_id > -1) {
        url = "/position-impress/by-dist";
        data = {
          distId: target_filter.district_id,
        };
      } else if (target_filter.state_id > -1) {
        url = "/position-impress/by-state";
        data = {
          stateId: target_filter.state_id,
        };
      } else if (target_filter.lang_id > -1) {
        url = "/position-impress/by-lang";
        data = {
          langId: target_filter.lang_id,
        };
      }

      let res = await api({
        url,
        method: "POST",
        responseType: "json",
        data,
      });
      if (res.code === 200) {
        setData({ totalData: res.data, pageNo: 0, pageData: res.data.slice(0, perPageCount) });
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const LanguageFilterChange = (e) => {
    setLangFilter(e.target.value);
    setDistrictfilter([]);
    setMandalfilter([]);
    setTarget_filter({ lang_id: +e.target.value, state_id: -1, district_id: -1, mandal_id: -1, village_id: -1 });
    getData({ lang_id: +e.target.value, state_id: -1, district_id: -1, mandal_id: -1, village_id: -1 });

    if (parseInt(e.target.value) === -1) {
      setStatefilter(-1);
      setLangFilter(-1);
      setSelectdistrict(-1);
      setSelectmandal(-1);
    }
  };

  const StateFilterChange = async (value) => {
    setStatefilter(value);
    setMandalfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        let districts = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictfilter(districts);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setStatefilter(-1);
      setSelectmandal(-1);
    }
    setTarget_filter({ lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1, village_id: -1 });
    getData({ lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1, village_id: -1 });
  };

  const DistrictFilterChanger = async (value) => {
    setSelectdistrict(value);

    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getMandalsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [value], langs: [langfilter] },
        });
        let mandals = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.mandal_name}` };
          mandals.push(temp);
        }
        setMandalfilter(mandals);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setSelectmandal(-1);
    }
    setTarget_filter({ district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id, village_id: -1 });
    getData({ district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id, village_id: -1 });
  };

  const MandalFilterChange = async (value) => {
    setSelectmandal(value);

    if (parseInt(value) === -1) {
      setSelectmandal(-1);
    }
    setTarget_filter({
      district_id: target_filter.district_id,
      mandal_id: value,
      village_id: -1,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
    });
    getData({
      district_id: target_filter.district_id,
      mandal_id: value,
      village_id: -1,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
    });
  };

  function formatNumber(value) {
    if (value < 1000) {
      return `${value}`;
    } else if (value >= 1000 && value < 1000000) {
      const kValue = (value / 1000).toFixed(2);
      return `${kValue}K`;
    } else if (value >= 1000000) {
      const mValue = (value / 1000000).toFixed(2);
      return `${mValue}M`;
    } else return 0;
  }

  useEffect(() => {
    if (localStorage.getItem("role") !== roles.ops && localStorage.getItem("role") !== roles.salesperson) navigate("/pagenotfound");
  }, []);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0 font-size-18">Positionwise Impressions</h4>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="flex items-center gap-3 w-full" style={{ "padding-bottom": "10px" }}>
            <aside className="flex items-center gap-3 justify-center mobHide">
              <div>
                <SlSelect placeholder="Select Language" name="lang" size="medium" onSlChange={LanguageFilterChange} value={langfilter}>
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>

                  {languageOptions.map((item) => {
                    return (
                      <SlOption key={item.value} value={item.value}>
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
              {langfilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select State"
                    name="state"
                    size="medium"
                    onSlChange={(e) => {
                      StateFilterChange(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {stateOptions
                      .filter((item) => item.lang_id === +langfilter)
                      .map((item) => {
                        return (
                          <SlOption key={item.state_id} value={item.state_id}>
                            {item.state_name}
                          </SlOption>
                        );
                      })}
                  </SlSelect>
                </div>
              )}
              {statefilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select District"
                    name="district"
                    size="medium"
                    onSlChange={(e) => {
                      DistrictFilterChanger(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {districtfilter.map((item) => {
                      return (
                        <SlOption key={item.value.dist_id} value={item.value.dist_id}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}

              {districtselect !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select Mandal"
                    name="mandal"
                    size="medium"
                    onSlChange={(e) => {    
                      MandalFilterChange(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {mandalfilter.map((item) => {
                      return (
                        <SlOption key={item.value.mandal_id} value={item.value.mandal_id}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
            </aside>
            <img
            src={filterSvg}
            onClick={() => setShowFilter(true)}
            alt="filter"
            className="mobileOnly ml-auto"
          ></img>
          </div>

          <div className="overflow-x-auto">
            <table className="table table-bordered table-impress" style={{ width: "100%", margin: "auto" }}>
              <thead className="sticky top-0">
                <tr>
                  <th>Position</th>
                  <th>Impressions</th>
                </tr>
              </thead>
              {data.pageData?.length && !loader ? (
                <tbody>
                  {data.pageData?.map((item, index) => (
                    <tr key={index}>
                      <td>{data.pageNo * perPageCount + index + 1}</td>
                      <td>{item ? formatNumber(+item) : 0}</td>
                    </tr>
                  ))}
                </tbody>
              ) : !data.pageData?.length && !loader ? (
                <NoDataFound colspan="15" />
              ) : (
                <TableLoader colspan="15" />
              )}
            </table>
          </div>
        </div>
        <div></div>
      </div>
      <div className="flex justify-end">
        {data.totalData.length > 1 && (
          <Paginator
            pageCount={Math.ceil(data.totalData.length / perPageCount)}
            handlePageClick={(event) => {
              const selectedPage = event.selected;
              const s = selectedPage * perPageCount;
              const e = selectedPage * perPageCount + perPageCount;
              // console.log(selectedPage,s,e)
              setData((prev) => {
                // console.log(prev.totalData.slice(s,e))
                return {
                  pageNo: selectedPage,
                  pageData: prev.totalData.slice(s, e),
                  totalData: prev.totalData,
                };
              });
            }}
            forcePage={0}
          />
        )}
      </div>
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="flex items-center gap-3 justify-center flex-wrap">
              <div className="w-full">
                <SlSelect placeholder="Select Language" name="lang" size="medium" onSlChange={LanguageFilterChange} value={langfilter}>
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>

                  {languageOptions.map((item) => {
                    return (
                      <SlOption key={item.value} value={item.value}>
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
              {langfilter !== -1 && (
                <div className="w-full">
                  <SlSelect
                    placeholder="Select State"
                    name="state"
                    size="medium"
                    onSlChange={(e) => {
                      StateFilterChange(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {stateOptions
                      .filter((item) => item.lang_id === +langfilter)
                      .map((item) => {
                        return (
                          <SlOption key={item.state_id} value={item.state_id}>
                            {item.state_name}
                          </SlOption>
                        );
                      })}
                  </SlSelect>
                </div>
              )}
              {statefilter !== -1 && (
                <div className="w-full">
                  <SlSelect
                    placeholder="Select District"
                    name="district"
                    size="medium"
                    onSlChange={(e) => {
                      DistrictFilterChanger(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {districtfilter.map((item) => {
                      return (
                        <SlOption key={item.value.dist_id} value={item.value.dist_id}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}

              {districtselect !== -1 && (
                <div className="w-full">
                  <SlSelect
                    placeholder="Select Mandal"
                    name="mandal"
                    size="medium"
                    onSlChange={(e) => {    
                      MandalFilterChange(+e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {mandalfilter.map((item) => {
                      return (
                        <SlOption key={item.value.mandal_id} value={item.value.mandal_id}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
            </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default PosWiseImpress;
